import * as React from 'react';
import * as moment from 'moment';
import { IConnectToDonorStatus, IListItem, IDonorConnectIldaUploadedFile, IBaseResponse, IDonorConnect } from '@nkr/models/index';
import { Dispatch, connect } from 'react-redux';
import { ICounselor, milestones } from './models';
import { AppActionCreators, DashActionCreators, IApplicationState, IAppState, IIldaUploadedFilesListResponse } from '@nkr/store/index';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Glyphicon, Label, Modal, Panel, Row } from 'react-bootstrap';
import { FormGroupWrapper, TableWrapper, ViewWrapper, TableWrapperLeftAligned } from './styles';
import MaskedInput from 'react-maskedinput';
import Log from '../donor-connect/log';
import UploadFile from './upload-file';
import { toast } from 'react-toastify';
import Files from './files-modal';

interface IProps {
    data: IDonorConnect,
    statusList: IConnectToDonorStatus[],
    actionList: IListItem[],
    userList: ICounselor[],
    clearFile: any,
    onStatusChange: (id: number, statusId: number) => void,
    onCounselorChange: (id: number, userId: number) => void,
    onNextFollowUpDateChange: (date: string) => void,
    onUpdateNextFollowUpDate: (id: number) => void,
    onRemoveNextFollowUpDate: (id: number) => void,
    onSaveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void,
    onCloseDrawer: () => void
}

interface IState {
    upload: File,
    description: string,
    showFiles: boolean,
    uploadFiles: IDonorConnectIldaUploadedFile[],
    validation: {
        description: boolean
    },
    dirty: boolean
}

interface IStateProps {
    app: IAppState
}


interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getUploadFileList: (registrationid: number) => Promise<IIldaUploadedFilesListResponse>,
    uploadIldaFile: (registrationid: number, ildafile: File, description: string) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

class ViewRegistration extends React.Component<TProps, IState> {
    readonly state: IState = {
        upload: this.props.clearFile,
        description: "",
        showFiles: false,
        uploadFiles: [],
        validation: {
            description: true
        },
        dirty: false
    };

    handleSaveLogEntry = (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => {
        this.props.onSaveLogEntry(id, dashRegistrationId, actionTaken, comments);
    }

    handleNextFollowUpDateChange = (e: any) => {
        this.props.onNextFollowUpDateChange(e.currentTarget.value);
    }

    handleSelectFile = (file: File) => {
        this.setState({
            upload: file
        });
    }

    handleDescription = (e: React.FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation.description = e.currentTarget.value != '';

        this.setState({
            description: e.currentTarget.value,
            validation
        });
    };

    handleSend = () => {
        let validation = this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            let { description: descriptionValid } = validation;
            let valid = descriptionValid;

            if (valid) {
                this.props.showLoading('Uploaded file, one moment please...').then(() => {
                    this.props.uploadIldaFile(this.props.data.id, this.state.upload, this.state.description).then(response => {

                        if (response.data.success) {

                            this.setState({
                                upload: null,
                                description: ''
                            });

                            toast.success('Ilda Uploaded Successfully');
                        } else {
                            toast.error('Could not upload the Ilda');
                        }

                        this.props.hideLoading();

                    });
                });
            }
        });
    }

    handleViewUploadedFiles = (registrationId: number) => {
        this.props.showLoading('Getting Uploaded files, one moment please...').then(() => {
            this.props.getUploadFileList(registrationId).then(response => {
                if (response.data.success) {
                    this.setState({
                        showFiles: true,
                        uploadFiles: response.data.results
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handleCancel = () => {
        this.setState({
            showFiles: false
        });
    }

    handleCloseView = () => {
        this.setState({
            upload: null,
            description: ''
        }, () => {
            this.props.onCloseDrawer()
        });
    }

    validate = () => {
        let { description } = this.state;

        return {
            description: description != '',
        };
    }

    getAlertStyle = () => {
        let nextFollowUpDate = moment(this.props.data.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true);

        let nextFollowUpDateIsPast = nextFollowUpDate.isValid() ? nextFollowUpDate.isBefore(moment(), 'day') : false;
        let nextFollowUpDateIsToday = nextFollowUpDate.isValid() ? nextFollowUpDate.isSame(moment(), 'day') : false;

        if (nextFollowUpDateIsPast) {
            return { level: 3, style: 'danger' };
        }

        if (nextFollowUpDateIsToday) {
            return { level: 2, style: 'warning' };
        }

        return null;
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const disableNextFollowUpDateSaveButton = moment(this.props.data.connectToDonorNextFollowUpDate, 'MM/DD/YYYY', true).isValid() == false;
        const alertStyle = this.getAlertStyle();
        const disableFormControl = this.state.upload == null;
        const uploadedFiles = this.state.uploadFiles;

        const valid = this.state.validation.description;

        return (
            <>
                {!valid && this.state.dirty && (
                    <Alert bsStyle='danger'>
                        The items below are required...
                    </Alert>
                )}

                <ViewWrapper>
                    <div className='modal-container'>
                        <Row>
                            <Col xs={12} lg={9} style={{ fontWeight: 500, fontSize: 25 }}>DASH Registration</Col>
                            <Col xs={12} lg={3} style={{ textAlign: 'right' }}><Button bsStyle="primary" onClick={this.handleCloseView}>Close View</Button></Col>
                        </Row>

                        <Row style={{ height: "15px" }}>
                            <Col xs={12} lg={8} style={{ fontWeight: 500 }}></Col>
                        </Row>


                        <Alert bsStyle='info' style={{ marginBottom: 10 }}>
                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Entry Source:</Col>
                                <Col xs={12} lg={3}>{this.props.data.entrySource}</Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Name:</Col>
                                <Col xs={12} lg={8}>{this.props.data.firstName} {this.props.data.lastName}</Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Email:</Col>
                                <Col xs={12} lg={8}>{this.props.data.email}</Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Phone Number(s):</Col>
                                <Col xs={12} lg={8}>
                                    {this.props.data.phoneNumber != '' ?
                                        <>
                                            <div>
                                                {this.props.data.phoneNumber}
                                            </div>

                                        </>
                                        :
                                        <>--</>
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Location:</Col>
                                <Col xs={12} lg={8}>
                                    {this.props.data.city != '' && this.props.data.state != '' ?
                                        <>{this.props.data.city}, {this.props.data.state}</>
                                        :
                                        <>--</>
                                    }
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} lg={3} style={{ fontWeight: 500 }}>Center:</Col>
                                <Col xs={12} lg={8}>
                                    {this.props.data.centerAlias ?? '- pending selection -'}
                                </Col>
                            </Row>
                        </Alert>

                        <Panel>
                            <Panel.Body>
                                <FormGroupWrapper>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Status:</Col>
                                    <Col xs={12} lg={8}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.props.data.connectToDonorStatusId}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onStatusChange(this.props.data.id, parseInt(e.currentTarget.value))}
                                        >
                                            {this.props.statusList.map((item, index) =>
                                                <option key={'st-' + index} value={item.id}>{item.description}</option>


                                            )}
                                        </FormControl>
                                    </Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Assigned Counselor:</Col>
                                    <Col xs={12} lg={8}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.props.data.connectToDonorAssignedUserId}
                                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.props.onCounselorChange(this.props.data.id, parseInt(e.currentTarget.value))}
                                        >
                                            <option value={0}>- Not Assigned -</option>
                                            {this.props.userList.map((item, index) =>
                                                <option key={'ac-' + index} value={item.id}>{item.firstName} {item.lastName}</option>
                                            )}
                                        </FormControl>
                                    </Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Upload ILDA File:</Col>
                                    <Col xs={12} lg={5}>
                                        <UploadFile
                                            elementName="Ilda"
                                            valid={true}
                                            disable={false}
                                            onSelectFile={this.handleSelectFile}
                                        />

                                        {this.state.upload != null && (
                                            <div style={{ marginTop: 5 }}>Selected File: {this.state.upload.name}</div>
                                        )}

                                    </Col>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}> <Button bsSize="sm" bsStyle="link" style={{ marginRight: 5 }} onClick={() => this.handleViewUploadedFiles(this.props.data.id)}><Glyphicon glyph='upload' style={{ marginRight: 5 }} />View uploaded files</Button></Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Description:</Col>
                                    <Col xs={12} lg={6}>
                                        <FormGroup validationState={this.state.dirty && !this.state.validation.description ? 'error' : null}>
                                            <FormControl
                                                value={this.state.description}
                                                name='description'
                                                bsSize='sm'
                                                style={{ width: 200 }}
                                                placeholder='At least 2 characters...'
                                                onChange={this.handleDescription}
                                                disabled={disableFormControl}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}> <Button disabled={disableFormControl} bsStyle="success" onClick={this.handleSend}>Upload Ilda File</Button></Col>
                                </FormGroupWrapper>

                                <FormGroupWrapper validationState={this.props.data.connectToDonorNextFollowUpDate == '' ? 'error' : null}>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Next Follow-Up:</Col>
                                    <Col xs={12} lg={8}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginRight: 5 }}>
                                                <MaskedInput
                                                    mask='11/11/1111'
                                                    placeholder='mm/dd/yyyy'
                                                    className='form-control'
                                                    value={this.props.data.connectToDonorNextFollowUpDate}
                                                    onChange={this.handleNextFollowUpDateChange}
                                                />
                                            </div>

                                            <div style={{ marginRight: 5 }}>
                                                <Button bsStyle='primary' bsSize='xs' disabled={disableNextFollowUpDateSaveButton} title='Save specified date' onClick={() => this.props.onUpdateNextFollowUpDate(this.props.data.id)}>
                                                    <Glyphicon glyph='ok' />
                                                </Button>
                                            </div>

                                            {this.props.data.connectToDonorNextFollowUpDate == '' && (
                                                <Label bsStyle='danger' style={{ padding: '.3em .6em' }}>This is required</Label>
                                            )}
                                        </div>
                                    </Col>
                                </FormGroupWrapper>

                                {alertStyle != null && (
                                    <Row style={{ marginBottom: 10 }}>
                                        <Col xs={12} lg={8} lgOffset={3} style={{ paddingLeft: 20 }}>
                                            <Label bsStyle={alertStyle.style}>
                                                {alertStyle.level == 3 && (
                                                    <>The next follow-up date is in the past</>
                                                )}

                                                {alertStyle.level == 2 && (
                                                    <>The next follow-up date is today</>
                                                )}
                                            </Label>
                                        </Col>
                                    </Row>
                                )}

                            </Panel.Body>
                        </Panel>

                        <Log
                            data={this.props.data}
                            statusList={this.props.statusList}
                            actionList={this.props.actionList}
                            userList={this.props.userList}
                            container={this}
                            isMobile={false}
                            onSaveLogEntry={this.handleSaveLogEntry}
                            onDeleteLogEntry={this.props.onDeleteLogEntry}
                        />

                        <Files show={this.state.showFiles} files={this.state.uploadFiles} onClose={this.handleCancel} />
                    </div>
                </ViewWrapper>
            </>
        );
    }
}


const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getUploadFileList: (id) => {
            return dispatch(DashActionCreators.getUploadedFilesList(id));
        },
        uploadIldaFile: (registrationid, ildafile, description) => {
            return dispatch(DashActionCreators.uploadIldaFile(registrationid, ildafile, description));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(ViewRegistration);


